import Box from "@mui/material/Box";
import { useParams } from "react-router-dom";
import TicketChatForm from "./TicketChatForm";

const TicketChatContainer = () => {
  const { ticketId } = useParams();
  return (
    ticketId && (
      <Box
        sx={{
          position: "fixed",
          bottom: 0,
          width: "100%",
          backgroundColor: "white",
        }}
      >
        <Box sx={{ margin: "0 auto", maxWidth: 768, p: 2 }}>
          <TicketChatForm itemId={ticketId} />
        </Box>
      </Box>
    )
  );
};

export default TicketChatContainer;
